import request from '@/utils/request'

// 查询银河打本游戏房间分页
export function pageGameRoom(query) {
  return request({
    url: '/played/game/room/page',
    method: 'get',
    params: query
  })
}

// 查询银河打本游戏房间列表
export function listGameRoom(query) {
  return request({
    url: '/played/game/room/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本游戏房间详细
export function getGameRoom(id) {
  return request({
    url: '/played/game/room/' + id,
    method: 'get'
  })
}

// 新增银河打本游戏房间
export function addGameRoom(data) {
  return request({
    url: '/played/game/room',
    method: 'post',
    data: data
  })
}

// 修改银河打本游戏房间
export function updateGameRoom(data) {
  return request({
    url: '/played/game/room',
    method: 'put',
    data: data
  })
}

// 删除银河打本游戏房间
export function delGameRoom(id) {
  return request({
    url: '/played/game/room/' + id,
    method: 'delete'
  })
}

// 跳转银河打本的房间步骤
export function goStep(id, type) {
  return request({
    url: '/played/game/room/go/step/' + id + '/' + type,
    method: 'put'
  })
}

// 后台关闭正在开启的房间
export function backgroundCloseRoom(data) {
  return request({
    url: '/played/game/room/background/close/room',
    method: 'post',
    data: data
  })
}
